type $EmailRouteEnums = {
  adminEmailVerify: 'admin_email_verify';
  adminPasswordReset: 'admin_password_reset';
  championshipAdminConfirm: 'championship_admin_confirm';
  championshipAdminPropose: 'championship_admin_propose';
  championshipAdminReject: 'championship_admin_reject';
  championshipAdminRequest: 'championship_admin_request';
  deletedRegattaEntry: 'deleted_regatta_entry';
  newAdvertisement: 'new_advertisement';
  newRegattaEntry: 'new_regatta_entry';
  newRegattaMessage: 'new_regatta_message';
  newRegattaProtest: 'new_regatta_protest';
  newRegattaProtestProtestee: 'new_regatta_protest_protestee';
  newRegattaProtestProtestor: 'new_regatta_protest_protestor';
  regattaAdminConfirm: 'regatta_admin_confirm';
  regattaAdminPropose: 'regatta_admin_propose';
  regattaAdminReject: 'regatta_admin_reject';
  regattaAdminRequest: 'regatta_admin_request';
  regattaProtestDecision: 'regatta_protest_decision';
};
export type $EmailRoute = $EmailRouteEnums[keyof $EmailRouteEnums];

export const emailRoute: $EmailRouteEnums = Object.freeze({
  adminEmailVerify: 'admin_email_verify',
  adminPasswordReset: 'admin_password_reset',
  championshipAdminConfirm: 'championship_admin_confirm',
  championshipAdminPropose: 'championship_admin_propose',
  championshipAdminReject: 'championship_admin_reject',
  championshipAdminRequest: 'championship_admin_request',
  deletedRegattaEntry: 'deleted_regatta_entry',
  newAdvertisement: 'new_advertisement',
  newRegattaEntry: 'new_regatta_entry',
  newRegattaMessage: 'new_regatta_message',
  newRegattaProtest: 'new_regatta_protest',
  newRegattaProtestProtestee: 'new_regatta_protest_protestee',
  newRegattaProtestProtestor: 'new_regatta_protest_protestor',
  regattaAdminConfirm: 'regatta_admin_confirm',
  regattaAdminPropose: 'regatta_admin_propose',
  regattaAdminReject: 'regatta_admin_reject',
  regattaAdminRequest: 'regatta_admin_request',
  regattaProtestDecision: 'regatta_protest_decision',
});
